import { Typography } from '@mui/material';
import { BackgroundCircularProgress, CircularProgress, LoaderWrapper, OuterWrapper } from './Loader.styles';

type LoaderProps = {
  hasLoadingText?: boolean;
  size?: string;
};

export const Loader = ({ hasLoadingText = true, size = '2.75rem' }: LoaderProps) => {
  return (
    <OuterWrapper>
      <LoaderWrapper>
        <BackgroundCircularProgress
          value={100}
          variant="determinate"
          size={size}
          data-testid="LoaderBackgroundCircularProgress"
        />
        <CircularProgress variant="indeterminate" size={size} data-testid="LoaderCircularProgress" />
      </LoaderWrapper>
      {hasLoadingText && <Typography variant="subtitle2">Please, wait...</Typography>}
    </OuterWrapper>
  );
};
